import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
/*
  Las letras del artefacto (rediseño del 18-oct): DM Sans para la interfaz y
  Poppins para los títulos y los números grandes. Vienen en el paquete (no se
  piden a Google); cada archivo baja sólo si la pantalla usa ese peso y esos
  caracteres (unicode-range).
*/
import '@fontsource-variable/dm-sans/index.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './index.css';
import { useAuthStore } from './features/auth/store/auth-store';
import { sesionVencidaAlCerrarElNavegador } from './lib/utils/recordar-sesion';
import { iniciarReinicioPorEmpresa } from './lib/stores/reinicio-por-empresa';

// Los stores con datos de empresa se vacían al cambiar de empresa u organización.
iniciarReinicioPorEmpresa();

// «Recordar sesión» sin marcar y el navegador se cerró desde el ingreso: se
// cierra la sesión antes de dibujar nada (ver `recordar-sesion.ts`).
if (sesionVencidaAlCerrarElNavegador()) useAuthStore.getState().logout();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
